import { observer } from "mobx-react-lite";
import { CompassIcon } from "lucide-react";

import { CosineSimilarityConfiguration } from "@/types/evaluate";
import { BlockProps } from "@/components/PowerBlock/Block";
import { withBlockStore } from "@/components/PowerBlock/Block/block-store";
import { createEmptySources } from "@/components/PowerBlock/Block/hooks";
import { useIsReadonly } from "@/components/PowerBlock/Block/readonly-context";
import SectionGroup from "@/components/PowerBlock/Block/SectionGroup";
import { DoubleSourceSelector } from "@/components/PowerBlock/Block/SourceSelectors";
import { required } from "@/components/PowerBlock/Block/validation/rules";
import { createBlockSchema } from "@/components/PowerBlock/Block/validation/schemaBuilder";

const validationSchema = createBlockSchema<CosineSimilarityConfiguration>()
  .requireName()
  .addRule(required("configuration.sources.0", "First source is required"))
  .addRule(required("configuration.sources.1", "Second source is required"))
  .build();

const CosineSimilarityBlockCore = observer(
  ({
    sources = createEmptySources(),
  }: Omit<BlockProps<CosineSimilarityConfiguration>, "DefaultFields">) => {
    const isReadonly = useIsReadonly();

    return (
      <SectionGroup
        title="Data Sources"
        description="Select the vectors or text embeddings to compare"
        icon={<CompassIcon className="h-4 w-4" />}
      >
        <DoubleSourceSelector
          sources={sources}
          firstName="First"
          secondName="Second"
          firstValidationPath="configuration.sources.0"
          secondValidationPath="configuration.sources.1"
          disabled={isReadonly}
        />
      </SectionGroup>
    );
  },
);

export default withBlockStore<CosineSimilarityConfiguration>(CosineSimilarityBlockCore, {
  validationSchema,
});
